export const Light = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2L16 7.38462" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 24.6155L16 30.0001" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M30 16L24.6154 16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M7.38461 16L2 16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M25.8995 25.8994L22.092 22.0919" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M9.9076 9.9082L6.1001 6.10071" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M25.8995 6.10059L22.092 9.90808" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M9.9076 22.0918L6.1001 25.8993" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="16" cy="16" r="5" stroke="currentColor" stroke-width="2"/>
</svg>`;
